import { ContentCountField } from './ContentCountField'
import { useField } from 'formik'
import { ContentCount as CountCountType } from 'types'
import React from 'react'

export const StoriesCountField = ({ name, interval }: { name: string; interval?: string }) => {
  const [field] = useField<[CountCountType]>(name)

  const storiesIndex = field.value.findIndex((value) => value.type === 'story')

  return <ContentCountField name={`${name}.${storiesIndex}`} label="Stories" interval={interval} />
}
